// extracted by mini-css-extract-plugin
module.exports = {"side-container":"side-container-1FBMGHdCXSAKzuYrmHwhkp","sideContainer":"side-container-1FBMGHdCXSAKzuYrmHwhkp","segment":"segment-1hUR4QwdojMwQbrpDOQqLA"};